import { APP_PATHS, FILESPACE_PATHS, WORKSPACE_PATHS } from '#constants';
import { buildUrl } from '../buildUrl';
export const appRoutes = {
    root: () => buildUrl(APP_PATHS.root),
    awsOffer: () => buildUrl(APP_PATHS.awsOffer),
    ssoLanding: () => buildUrl(APP_PATHS.ssoLanding),
    inviteLanding: () => buildUrl(APP_PATHS.inviteLanding),
    activateAccount: () => buildUrl(APP_PATHS.activateAccount),
    invite: () => buildUrl(APP_PATHS.invite),
    accountRecovery: () => buildUrl(APP_PATHS.accountRecovery),
    backupCodeLogin: () => buildUrl(APP_PATHS.backupCodeLogin),
    passwordReset: () => buildUrl(APP_PATHS.passwordReset),
    login: () => buildUrl(APP_PATHS.login),
    register: () => buildUrl(APP_PATHS.register),
    verifyEmail: () => buildUrl(APP_PATHS.verifyEmail),
    account: () => buildUrl(APP_PATHS.account),
    zendeskAuth: (returnTo) => {
        const params = new URLSearchParams({ return_to: returnTo });
        return `${buildUrl(APP_PATHS.zendeskAuth)}?${params.toString()}`;
    },
};
export const workspaceRoutes = {
    workspaces: () => buildUrl(WORKSPACE_PATHS.workspaces),
    workspacesCreate: () => buildUrl(WORKSPACE_PATHS.workspacesCreate),
    workspacesNoWorkspaces: () => buildUrl(WORKSPACE_PATHS.workspacesNoWorkspaces),
    workspaceOnboarding: () => buildUrl(WORKSPACE_PATHS.workspaceOnboarding),
    filespaceMigrate: () => buildUrl(WORKSPACE_PATHS.filespaceMigrate),
    workspace: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspace, { workspaceId }),
    workspaceLock: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceLock, { workspaceId }),
    workspaceSuspended: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSuspended, { workspaceId }),
    workspaceFilespaceCreate: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceFilespaceCreate, { workspaceId }),
    workspaceSettings: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettings, { workspaceId }),
    workspaceSettingsGeneral: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsGeneral, { workspaceId }),
    workspaceSettingsMembers: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsMembers, { workspaceId }),
    workspaceSettingsMember: ({ memberId, workspaceId, }) => buildUrl(WORKSPACE_PATHS.workspaceSettingsMember, {
        memberId,
        workspaceId,
    }),
    workspaceSettingsGroups: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsGroups, { workspaceId }),
    workspaceSettingsGroup: ({ groupId, workspaceId, }) => buildUrl(WORKSPACE_PATHS.workspaceSettingsGroup, {
        groupId,
        workspaceId,
    }),
    workspaceSettingsPermissions: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsPermissions, { workspaceId }),
    workspaceSettingsTwoFactorAuthentication: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsTwoFactorAuthentication, {
        workspaceId,
    }),
    workspaceSettingsSso: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsSso, { workspaceId }),
    workspaceSettingsDomainManagement: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsDomainManagement, {
        workspaceId,
    }),
    workspaceSettingsDeveloperTools: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsDeveloperTools, {
        workspaceId,
    }),
    workspaceSettingsServiceAccounts: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsServiceAccounts, {
        workspaceId,
    }),
    workspaceSettingsServiceAccount: ({ accountId, workspaceId, }) => buildUrl(WORKSPACE_PATHS.workspaceSettingsServiceAccount, {
        accountId,
        workspaceId,
    }),
    workspaceSettingsBillingPlans: (workspaceId) => buildUrl(WORKSPACE_PATHS.workspaceSettingsBillingPlans, {
        workspaceId,
    }),
};
export const filespaceRoutes = {
    filespace: ({ filespaceId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespace, { filespaceId, workspaceId }),
    filespaceBrowser: ({ filespaceId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespaceBrowser, {
        filespaceId,
        workspaceId,
    }),
    filespaceDashboard: ({ filespaceId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespaceDashboard, {
        filespaceId,
        workspaceId,
    }),
    filespaceSnapshots: ({ filespaceId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespaceSnapshots, {
        filespaceId,
        workspaceId,
    }),
    filespaceSettings: ({ filespaceId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespaceSettings, {
        filespaceId,
        workspaceId,
    }),
    filespacePermissions: ({ filespaceId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespacePermissions, {
        filespaceId,
        workspaceId,
    }),
    filespacePermissionsFsEntry: ({ filespaceId, fsEntryId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespacePermissionsFsEntry, {
        filespaceId,
        fsEntryId,
        workspaceId,
    }),
    filespacePermissionsFsEntryCreate: ({ filespaceId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespacePermissionsFsEntryCreate, {
        filespaceId,
        workspaceId,
    }),
    filespacePermissionsPrincipal: ({ filespaceId, principalId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespacePermissionsPrincipal, {
        filespaceId,
        principalId,
        workspaceId,
    }),
    filespacePermissionsPrincipalCreate: ({ filespaceId, principalId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespacePermissionsPrincipalCreate, {
        filespaceId,
        principalId,
        workspaceId,
    }),
    filespaceLucidLinkConnect: ({ filespaceId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespaceLucidLinkConnect, {
        filespaceId,
        workspaceId,
    }),
    filespaceLucidLinkConnectDataStore: ({ dataStoreRef, filespaceId, workspaceId, }) => buildUrl(FILESPACE_PATHS.filespaceLucidLinkConnectDataStore, {
        dataStoreRef,
        filespaceId,
        workspaceId,
    }),
};
